import { envs } from '@/shared/constants/envs';

export const testId = (testId?: string) =>
  envs.DISPLAY_DATA_TEST_ID ? testId : undefined;
